import React from "react";

const Title = ({ text }) => {
  return (
    <h2 style={{ width: "100%", fontSize: "24px" }} className="text-black-tint-20 h2 mb10">
      {text}
    </h2>
  );
};

export { Title };
